import { CountFilterType } from 'modules/queryBuilder/types';
import { useCountFilterSelectOptions } from './useCountFilterSelectOptions';
import { ConditionSingleValueSelectProps } from '../types';
import { QueryBuilderSelect } from '../Selects';

export const CountFilterTypeDropdown = ({
  value,
  ...props
}: ConditionSingleValueSelectProps<CountFilterType>) => {
  const options = useCountFilterSelectOptions();
  return <QueryBuilderSelect {...props} value={value} options={options} />;
};
